import React, { Component } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import Grid from '@material-ui/core/Grid';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Sidebar from "../../components/Sidebar/Sidebar";
import About from './../../views/About/About'
import Setting from './../../views/Setting/Setting'
import ManageItems from './../../views/ManageItems/ManageItems'

class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            dropDownOpen: false,
            toggle:false
        };

    }
    handleToggleMenu = ()=>{
        this.setState({toggle:! this.state.toggle})
    }
    render() {
        const { toggle }=this.state;
        const collapseClass = (this.state.collapseClass ? 'collapsed-sidebar' : '');
        return (
            <div className={`main-container ${toggle ? "is-active":""}`}>

                <Header toggleMenu={this.handleToggleMenu} open={toggle} />
                <div className="content">
                    <Sidebar toggleMenu={this.handleToggleMenu} />
                    <main className={`main-content ${collapseClass}`}>
                        <div className="main-wrapper">
                            <Route path="/about" component={About} />
                            <Route path="/setting" component={Setting} />
                            <Route path="/" exact component={ManageItems} />
                        </div>
                    </main>

                </div>

            </div>
        );
    }
}


export default Main;

